var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.29 5.81293C15.5087 6.11945 15.6181 6.27342 15.6181 6.50008C15.6181 6.72745 15.5087 6.88071 15.29 7.18722C14.3071 8.56584 11.7967 11.5368 8.42282 11.5368C5.04823 11.5368 2.53852 8.56512 1.55564 7.18722C1.33691 6.88071 1.22754 6.72673 1.22754 6.50008C1.22754 6.2727 1.33691 6.11945 1.55564 5.81293C2.53852 4.43431 5.04895 1.46338 8.42282 1.46338C11.7974 1.46338 14.3071 4.43503 15.29 5.81293Z",
    stroke: "#045BA7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5818 6.50014C10.5818 5.92764 10.3544 5.3786 9.94958 4.97379C9.54477 4.56897 8.99573 4.34155 8.42323 4.34155C7.85074 4.34155 7.3017 4.56897 6.89688 4.97379C6.49207 5.3786 6.26465 5.92764 6.26465 6.50014C6.26465 7.07263 6.49207 7.62167 6.89688 8.02649C7.3017 8.4313 7.85074 8.65872 8.42323 8.65872C8.99573 8.65872 9.54477 8.4313 9.94958 8.02649C10.3544 7.62167 10.5818 7.07263 10.5818 6.50014Z",
    stroke: "#045BA7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7f18ea747124a0ce7c8e2adba395e2ea.svg";
export { ForwardRef as ReactComponent };